import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import StyledChart from './components/chart/styles';
import ScrollToTop from './components/scroll-to-top';
import ErrorBoundary from './components/error-boundary';
import { PwaStatus } from './components/pwa';
// ----------------------------------------------------------------------

export default function App() {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <HelmetProvider>
        <BrowserRouter>
          <ThemeProvider>
            <ScrollToTop />
            <StyledChart />
            <PwaStatus />
            <ErrorBoundary>
              <Router />
            </ErrorBoundary>
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}
